<template>
  <section v-editable="cms" :class="[name]" :style="mainCssVars">
    <grid
      :class="[{ 'grid--container': !fullwidth }, `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__grid-content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <a-heading
          v-if="cms.media_heading"
          :cms="{ heading: cms.media_heading }"
          html-tag="h4"
          :class="`${name}__heading`"
        />
        <m-slide-v2 :cms="cms" />
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="cms.media_copy"
          :class="`${name}__caption`"
          v-html="$options.filters.markdown(cms.media_copy)"
        />
        <!--eslint-enable-->
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/molecules/m-articles/m-article-media.data'
import MSlideV2 from '~/components/molecules/m-slide/m-slide-v2'

export default {
  components: { MSlideV2 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-media',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    fullwidth() {
      return this.cms.fullwidth || false
    },
    mainCssVars() {
      return {
        top: '73px',
        'z-index': '-1000',
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || null,
        '--spacing-top': this.cms.spacing_top || '30px',
        '--spacing-bottom': this.cms.spacing_bottom || '30px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

::v-deep .m-slide-v2 {
  min-height: initial;
  picture,
  img {
    min-height: initial;
    object-fit: initial;
  }
}

.m-article-media {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep .m-slide-v2__media {
    min-height: inherit;
    max-height: inherit;
  }

  // standard video
  ::v-deep .a-video__video {
    width: 100%;
    position: relative;
    top: initial;
    left: initial;
    transform: initial;
  }

  // youtube/vimeo
  ::v-deep .a-video__video--youtube,
  ::v-deep .a-video__video--vimeo {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__heading,
  &__caption {
    text-align: center;
  }

  &__caption {
    font-style: italic;
  }

  &__grid {
    align-items: center;
  }
}
</style>
